import { render, staticRenderFns } from "./FrameStainSelector.vue?vue&type=template&id=72c87f64&scoped=true&"
import script from "./FrameStainSelector.vue?vue&type=script&lang=ts&"
export * from "./FrameStainSelector.vue?vue&type=script&lang=ts&"
import style0 from "./FrameStainSelector.vue?vue&type=style&index=0&id=72c87f64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c87f64",
  null
  
)

export default component.exports